import MultipoolDispatcherAbi from 'abis/MultipoolDispatcher.json'
import { MultipoolDispatcher } from 'abis/types'
import { MULTIPOOL_DISPATCHER } from 'constants/addresses'
import { SupportedChainId } from 'constants/chains'
import { nativeOnChain } from 'constants/tokens'
import { ContractInput, useMultiChainTokensPriceUsd } from 'hooks/useMultiChainTokensPriceUsd'
import { useMemo } from 'react'
import { currencyKey } from 'utils/currencyKey'

import { ContractMap, useContractMultichain } from '../Pools/hooks'
import { PositionInfo } from './cache'

export function usePriceValues(position: PositionInfo) {
  const priceA = position.prices?.[0]
  const priceB = position.prices?.[1]
  return { priceA, priceB }
}

export function useStrategyPriceMap(positions: PositionInfo[] | undefined) {
  const contracts = useMemo(() => {
    if (!positions || !positions.length) return []
    // Avoids fetching duplicate tokens by placing in map
    const contractMap = positions.reduce((acc: { [key: string]: ContractInput }, { multipool: { token0, token1 } }) => {
      acc[currencyKey(token0)] = {
        chain: token0.chainId,
        address: token0.isToken ? token0.address : nativeOnChain(token0.chainId).wrapped.address,
      }
      acc[currencyKey(token1)] = {
        chain: token1.chainId,
        address: token1.isToken ? token1.address : nativeOnChain(token1.chainId).wrapped.address,
      }
      return acc
    }, {})
    return Object.values(contractMap)
  }, [positions])

  const { priceMap, loading } = useMultiChainTokensPriceUsd(contracts)
  return { priceMap, pricesLoading: loading }
}

export function useMultipoolDispatcherContracts(chainIds: SupportedChainId[]): ContractMap<MultipoolDispatcher> {
  return useContractMultichain<MultipoolDispatcher>(MULTIPOOL_DISPATCHER, MultipoolDispatcherAbi, chainIds)
}
